import React, {useEffect, useState} from "react";

import {FormattedMessage, FormattedNumber, IntlProvider, useIntl} from 'react-intl';
import * as StorageService from "../../services/StorageService.js";
import analyticsLogEvent from "../../services/FirebaseService";
import {
    CARDS,
    FIREBASE_SCREEN_NAMES,
    HEADER_SIZE,
    LOCALSTORAGE_ITEMS,
    PAYMENT_TYPES,
    USER_TYPES
} from "../../util/Constants.js";
import Header from "../../components/Header.js";
import * as ProductService from "../../services/ProductService.js";
import Spinner from '../../components/Spinner.js';
import {EventBus} from "../../util/EventBus";
import QuantityModifier from "../../components/QuantityModifier";
import {getProdExtrasFromCart, getProdName, getProdOptionsFromCart, getProductsOrderFromCart} from "../../util/common";
import {PATH} from "../../routes/routes.js";
import TakeAwayOrderReviewActionsBar from "../../components/Actionsbar/TakeAwayOrderReviewActionsBar";
import locationImg from "../../assets/img/icon_location_2.svg";
import Moment from "react-moment";
import {DATE_FORMAT} from "../../util/DateUtil";
import * as PaymentHandler from "../../handlers/HandlerPayment";
import {useLocation, useNavigate} from "react-router";

function TakeAwayOrderReview() {
    const navigateTo = useNavigate();
    const useQuery = () => new URLSearchParams(useLocation().search);
    const query = useQuery();
    const paymentStatus = query.get('status');
    const shopDetails = StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS) ? JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)) : null;
    const allowedPaymentMethodsForPickup = shopDetails?.merchantConfig?.pmtMethodsForPickup;
    const allowedPaymentMethodsForDelivery = shopDetails?.merchantConfig?.pmtMethodsForDelivery;
    const deliveryInfo  = shopDetails?.merchantConfig?.deliveryInfo;
    const estimatedDeliveryTime =  (shopDetails ? (typeof shopDetails.merchantConfig.weekDeliverySchedule?.estimatedDeliveryTime !== "undefined" ? shopDetails.merchantConfig.weekDeliverySchedule?.estimatedDeliveryTime: null) : false);
    const pickupTime =  (shopDetails ? (typeof shopDetails.merchantConfig.weekPickupSchedule?.estimatedPickupTime !== "undefined" ? shopDetails.merchantConfig.weekPickupSchedule?.estimatedPickupTime : null) : false);
    const shopLanguage = StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS) ? JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)).lang : null;
    const currency = shopDetails ? shopDetails.currency : null;
    const userType = StorageService.getItem(LOCALSTORAGE_ITEMS.USER_TYPE) ? StorageService.getItem(LOCALSTORAGE_ITEMS.USER_TYPE) : null;
    const userInfo = StorageService.getItem(LOCALSTORAGE_ITEMS.USER_INFO) ? JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.USER_INFO)) : null;
    const allowOrdering = (shopDetails ? (typeof shopDetails.merchantConfig.allowOrdering !== "undefined" ? shopDetails.merchantConfig.allowOrdering : null) : false);
    const allowTakeAwayPickupOrdering = (shopDetails ? (typeof shopDetails.merchantConfig.takeawayPickup !== "undefined" ? shopDetails.merchantConfig.takeawayPickup : null) : false);
    const allowTakeAwayDeliveryOrdering = (shopDetails ? (typeof shopDetails.merchantConfig.homeDelivery !== "undefined" ? shopDetails.merchantConfig.homeDelivery : null) : false);
    const places = {
        TAKE_AWAY: "TAKE_AWAY",
        DELIVERY: "DELIVERY"
    }


    const PAYMENT_STATUSES = {
        PENDING: "pending",
        FAILED: "failed"
    }

    const visible = "visible";
    const hidden = "hidden";

    const defaultPlace = (() => {
        if (allowTakeAwayPickupOrdering && pickupTime !== null) {
            return places.TAKE_AWAY;
        }
        if (allowTakeAwayDeliveryOrdering && estimatedDeliveryTime !== null ) {
            return places.DELIVERY;
        }
        return null;
    })();

    const intl = useIntl();
    const [state, setState] = useState({
        loading: false,
        isSubmitBtnEnabled: true,
        errorMsg: null,
        cashOrCardModalStyle: hidden,
        currentCart: StorageService.getItem(LOCALSTORAGE_ITEMS.CURRENT_CART) ? JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.CURRENT_CART)) : null,
        outOfStock: [],
        contactName: userInfo?.firstName ? userInfo?.firstName + " " : null + userInfo?.lastName ? userInfo?.lastName : null,
        phone: userInfo?.phone ? userInfo?.phone : null,
        address: null,
        place: defaultPlace,
        selectedPaymentType: PAYMENT_TYPES.AT_PICKUP,
        selectedCard: CARDS.CURRENT
    });
    useEffect(() => {

        analyticsLogEvent("screen_view", {
            firebase_screen: FIREBASE_SCREEN_NAMES.ORDER_REVIEW,
            firebase_screen_class: FIREBASE_SCREEN_NAMES.ORDER_REVIEW
        });
    }, []);

    let buttonClicked = false;

    useEffect(() => {
        if (paymentStatus === PAYMENT_STATUSES.PENDING) {
            let delayDebounceFn = null;
            delayDebounceFn = setTimeout(() => {
                StorageService.removeItem(LOCALSTORAGE_ITEMS.CURRENT_CART);
                navigateTo(PATH.TAKEAWAY_THANK_YOU + "/" + StorageService.getItem(LOCALSTORAGE_ITEMS.ORDER_ID));
            }, 3000)
            return () => clearTimeout(delayDebounceFn);
        }
    }, []);

    useEffect(() => {
        if (state.currentCart && getProductsOrderFromCart(state.currentCart).length === 0) {
            navigateTo(PATH.TAKEAWAY);
        }
        if (!state.currentCart) {
            navigateTo(PATH.TAKEAWAY);
        }
    }, [state.currentCart]);


    const showNoAccountPopup = () => {
        EventBus.dispatch("accessingOnlyLoggedUsersFeature");
    }


    const getTotalProducts = (orderDetails) => {
        let totalProducts = 0;
        orderDetails?.forEach(product => {
            totalProducts += product.quantity;
        })
        return totalProducts;
    }

    const getTotalPrice = (orderDetails) => {
        let price = 0;
        orderDetails?.forEach(product => {
            product.choices.forEach(c => {
                price += c.price * c.quantity;
            });
        })
        return price;
    }


    const increaseQuantity = (product, choice) => {
        return function (e) {
            e.stopPropagation();
            const category = product.category;
            const newCart = {
                ...state.currentCart
            }
            let productEntry = newCart[category][product.name];
            if (productEntry) {
                productEntry = {
                    ...productEntry,
                    "quantity": productEntry.quantity + 1,
                }

                let choices = productEntry.choices;
                let found = false;

                choices.forEach(c => {
                    if (!found && c.option == choice.option && c.msg == choice.msg &&
                        (c.extras === choice.extras ||
                            c.extras != null && choice.extras != null &&
                            JSON.stringify(c.extras) === JSON.stringify(choice.extras))
                    ) {
                        c.quantity += 1;
                        found = true;
                        return;
                    }
                });

                if (found) {
                    newCart[category] = {
                        ...newCart[category],
                        [product.name]: productEntry
                    }
                }
            }

            StorageService.setItem(LOCALSTORAGE_ITEMS.CURRENT_CART, JSON.stringify(newCart));

            setState({
                ...state,
                currentCart: newCart
            })
        };
    }

    const decreaseQuantity = (product, choice) => {
        return function (e) {
            e.stopPropagation();
            const category = product.category;
            const newCart = {
                ...state.currentCart
            }
            let productEntry = newCart[category][product.name];
            if (productEntry) {
                if (productEntry.quantity > 1) {
                    productEntry = {
                        ...productEntry,
                        "quantity": productEntry.quantity - 1,
                    }

                    let choices = productEntry.choices;
                    let found = false;

                    for (let i = 0; i < choices.length; i++) {
                        const c = choices[i];
                        if (!found && c.option == choice.option && c.msg == choice.msg &&
                            (c.extras === choice.extras ||
                                c.extras != null && choice.extras != null &&
                                JSON.stringify(c.extras) === JSON.stringify(choice.extras))
                        ) {
                            c.quantity -= 1;
                            if (c.quantity == 0) {
                                choices.splice(i, 1);
                            }
                            found = true;
                            break;
                        }
                    }

                    if (found) {
                        newCart[category] = {
                            ...newCart[category],
                            [product.name]: productEntry
                        }
                    }
                } else {
                    delete newCart[category][product.name];
                }
            }

            StorageService.setItem(LOCALSTORAGE_ITEMS.CURRENT_CART, JSON.stringify(newCart));

            setState({
                ...state,
                currentCart: newCart
            })
        };
    }

    const getEstimatedTimePickup = () => {
        const date = new Date();
        const currentTime = date.getTime();
        const timeForPickup = pickupTime * 60 * 1000;
        return new Date(currentTime + timeForPickup);
    }

    const getEstimatedTimeDelivery = () => {
        const date = new Date();
        const currentTime = date.getTime();
        const timeForDelivery = estimatedDeliveryTime * 60 * 1000;
        return new Date(currentTime + timeForDelivery);
    }

    const validateInputs = () => {

        if ((state.place === places.DELIVERY && state.address === null) || (state.place === places.DELIVERY && !state.address.replace(/\s/g, '').length) || state.place === places.DELIVERY && state.address === "") {
            return <FormattedMessage id="PleaseFillTheAddressField"/>;
        } else if ((state.place === places.DELIVERY && state.contactName === null) || (state.place === places.TAKE_AWAY && state.contactName === null)) {
            return <FormattedMessage id="PleaseFillTheNameField"/>;
        } else {
            return null;
        }
        if (state.contactName === null || state.contactName === "" || !state.contactName.replace(/\s/g, '').length) {
            return <FormattedMessage id="PleaseFillTheNameField"/>;
        } else if (state.phone === null || state.phone === "" || !state.phone.replace(/\s/g, '').length) {
            return <FormattedMessage id="PleaseFillThePhoneField"/>;
        } else if (!/^\+?[0-9]{3,}$/.test(state.phone)) {
            return <FormattedMessage id="PleaseFillThePhoneField"/>;
        } else return null;
    }




    const openCashOrCardPopup = () => {
        setState({
            ...state,
            cashOrCardModalStyle: visible
        })
    }
    const closeCashOrCardPopup = () => {
        setState({
            ...state,
            cashOrCardModalStyle: hidden
        })
    }


    const handleCashButton = () => {
        if (buttonClicked) {
            return;
        }
        buttonClicked = true;
        closeCashOrCardPopup();
        checkoutProductsOrder(PAYMENT_TYPES.CASH).then(r => {
            buttonClicked = false;
            StorageService.removeItem(LOCALSTORAGE_ITEMS.CURRENT_CART);
            navigateTo(PATH.TAKEAWAY_THANK_YOU + "/" + StorageService.getItem(LOCALSTORAGE_ITEMS.ORDER_ID));
        });
    }

    const handleCardButton = () => {
        if (buttonClicked) {
            return;
        }
        buttonClicked = true;
        closeCashOrCardPopup();
        checkoutProductsOrder(PAYMENT_TYPES.CARD).then(r => {
            buttonClicked = false;
            StorageService.removeItem(LOCALSTORAGE_ITEMS.CURRENT_CART);
            navigateTo(PATH.TAKEAWAY_THANK_YOU + "/" + StorageService.getItem(LOCALSTORAGE_ITEMS.ORDER_ID));

        });
    }



    const initializeStripePayment = (stripeConfig) => {
        PaymentHandler.createProductsOrderStripePaymentLinkHandler(stripeConfig).then(response => {
            if (response.data.error === null) {
                window.location.href = response.data.paymentLink;
            }else{
                setState({
                    ...state,
                    errorMsg: response.data.error
                })
            }
        })
    }


    const handleSubmit = () => {

        if (state.phone === null || state.phone === undefined || state.phone === "") {
            navigateTo({
                pathname: PATH.PROFILE_UPDATE_PHONE,
                search: "?redirect=" + PATH.TAKEAWAY_ORDER_REVIEW
            });
        }
        if (!state.isSubmitBtnEnabled) {
            return;
        }
        setState({
            ...state,
            isSubmitBtnEnabled: false,
            loading: true,
        })

        if (state.selectedPaymentType === PAYMENT_TYPES.AT_PICKUP || state.selectedPaymentType === PAYMENT_TYPES.AT_DELIVERY) {
            const error = validateInputs();
            if (error) {
                setState({
                    ...state,
                    errorMsg: error
                })
                return;
            }
            openCashOrCardPopup();
        } else if (state.selectedPaymentType === PAYMENT_TYPES.ONLINE) {
            const error = validateInputs();
            if (error) {
                setState({
                    ...state,
                    errorMsg: error
                })
                return;
            }




            checkoutProductsOrder(PAYMENT_TYPES.ONLINE).then((r) => {
                if (r === true) {
                    const currentUrl = window.location.href;
                    let stripeConfig = {
                        shop: StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME),
                        user: StorageService.getItem(LOCALSTORAGE_ITEMS.USER_EMAIL),
                        oid: StorageService.getItem(LOCALSTORAGE_ITEMS.ORDER_ID),
                        successUrl: currentUrl.split("?")[0] + "?status=pending",
                        cancelUrl: currentUrl.split("?")[0] + "?status=failed"
                    }
                    initializeStripePayment(stripeConfig);
                }
            });
        }
    }


    const checkoutProductsOrder = async (chosenPaymentMethod) => {

        const error = validateInputs();
        if (error) {
            setState({
                ...state,
                errorMsg: error
            })
            return;
        }

        let response = null;
        setState({
            ...state,
            isSubmitBtnEnabled: false,
            loading: true,
            cashOrCardModalStyle: hidden
        })

        if (!state.isSubmitBtnEnabled || state.loading) {
            return;
        }

        response = await sendOrder(chosenPaymentMethod);

        if (response.ok) {
            StorageService.setItem(LOCALSTORAGE_ITEMS.ALL_ORDER_PRODUCTS, JSON.stringify(response.data));
            StorageService.setItem(LOCALSTORAGE_ITEMS.ORDER_ID, response.data.oid);

            return true;
        } else if (response.data.internalCode === "19") { // product out of stock
            const outOfStockProductPid = [];
            for (const property in state.currentCart) {
                for (const productName in state.currentCart[property]) {
                    if (state.currentCart[property][productName].pid === response.data.internalMsg) {
                        outOfStockProductPid.push(state.currentCart[property][productName].pid)
                        setState({
                            ...state,
                            loading: false,
                            errorMsg: <FormattedMessage id="SomeProductsJustWentOutOfStock"/>,
                            outOfStock: outOfStockProductPid
                        })
                    }
                }
            }

            return false;
        } else {
            setState({
                ...state,
                isSubmitBtnEnabled: true,
                loading: false
            }, () => {

                EventBus.dispatch("genericErrorMsg");
                console.log("Error sending order");
            });

            return false;
        }


    }
    const sendOrder = async (chosenPaymentMethod) => {

        const body = {
            "shop": StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME),
            "user": StorageService.getItem(LOCALSTORAGE_ITEMS.USER_EMAIL),
            "clientApp": "WEB_ORDERING",
            "name": state.contactName,
            "contact": state.phone || null,
            "place": state.place || null,
            "address": state.address || null,
            "paymentMethod": chosenPaymentMethod || null,
            "products": getProductsOrderFromCart(state.currentCart).flatMap(a => {
                return a.choices.map(c => {
                    return {
                        "pid": a.pid,
                        "quantity": c.quantity,
                        "msg": c.msg ? c.msg : null,
                        "option": c.option ? c.option : null,
                        "extras": c.extras.length > 0 ? c.extras.map(e => e.pid) : null
                    }
                });
            })
        }

        const response = await ProductService.createProductsOrder(body);
        return response;
    }



    const handleNameInput = (value) => {
        setState({
            ...state,
            contactName: value
        });

    }



    const handleAddressInput = (value) => {
        setState({
            ...state,
            address: value
        });
    }


    const changeSelectedPlace = (place) => {
        if (place === places.DELIVERY) {
            setState({
                ...state,
                place: places.DELIVERY,
                selectedPaymentType: PAYMENT_TYPES.AT_DELIVERY
            })
        } else {
            setState({
                ...state,
                place: places.TAKE_AWAY,
                selectedPaymentType: PAYMENT_TYPES.AT_PICKUP
            })
        }
    }


    const setPaymentType = (type) => {
        setState({
            ...state,
            selectedPaymentType: type,
            errorMsg: null
        })
    }

    const toUpdatePhone = () => {
        navigateTo(PATH.PROFILE_UPDATE_PHONE);
    }


    return state.currentCart ? (
            <>
                <Header
                    headerSize={HEADER_SIZE.SMALL}
                    headerTitle={<FormattedMessage id="OrderReview"/>}
                    hasBackBtn={true}
                    hasModal={true}
                />

                {/*START PAGE-CONTENT*/}
                <main className={"page-content" + (paymentStatus === PAYMENT_STATUSES.PENDING ? " disabled" : "")}>


                    {/*START CASH OR CARD MODAL*/}
                    <div className={state.cashOrCardModalStyle + " modal-overlay "}
                         onClick={(e) => closeCashOrCardPopup()}></div>
                    <div className="modal">
                        <div className="row">
                            <div className="modal-title"><FormattedMessage id="ChoosePaymentMethod"/></div>
                        </div>

                        <div className="row buttons-row">

                            {state.place === places.DELIVERY && allowedPaymentMethodsForDelivery?.includes(PAYMENT_TYPES.CASH) ?

                                <a className=" btn btn-outlined btn-md" id="CASH"
                                   onClick={handleCashButton}><FormattedMessage
                                    id="Cash"/></a>


                                : state.place === places.TAKE_AWAY && allowedPaymentMethodsForPickup?.includes(PAYMENT_TYPES.CASH) ? (
                                    <a className=" btn btn-outlined btn-md" id="CASH"
                                       onClick={handleCashButton}><FormattedMessage
                                        id="Cash"/></a>
                                ) : null}


                            {state.place === places.DELIVERY && allowedPaymentMethodsForDelivery?.includes(PAYMENT_TYPES.CARD) ?

                                <a className="btn btn-outlined btn-md" id="CARD"
                                   onClick={handleCardButton}><FormattedMessage
                                    id="Card"/></a>


                                : state.place === places.TAKE_AWAY && allowedPaymentMethodsForPickup?.includes(PAYMENT_TYPES.CARD) ? (
                                    <a className="btn btn-outlined btn-md" id="CARD"
                                       onClick={handleCardButton}><FormattedMessage
                                        id="Card"/></a>
                                ) : null}


                        </div>
                    </div>
                    {/*END CASH OR CARD MODAL*/}


                    {/*START ORDER DETAILS*/}
                    <section className="order-details-card">
                        <div className="card-content">
                            {getProductsOrderFromCart(state.currentCart)?.map((product, productIndex) =>
                                <div key={"productIndex" + productIndex}>
                                    {product.choices?.map((choice, choiceIndex) =>
                                        choice.msg || choice.option || choice.extras?.length > 0 ?
                                            <div key={choiceIndex} className="product with-choices with-quantity-modifier">
                                                <div className="row">
                                                    <QuantityModifier
                                                        onlyLoggedUser={false}
                                                        quantity={choice.quantity}
                                                        increaseQuantity={state.isSubmitBtnEnabled ? increaseQuantity(product, choice) : void (0)}
                                                        decreaseQuantity={state.isSubmitBtnEnabled ? decreaseQuantity(product, choice) : void (0)}
                                                    />
                                                    <span
                                                        className={state.outOfStock?.includes(product.pid) ? "prod-name danger ml-0" : "prod-name ml-0"}>
                                                            {getProdName(product)}
                                                        </span>
                                                    <span className="prod-price">&nbsp;
                                                        <IntlProvider
                                                            locale={StorageService.getItem(LOCALSTORAGE_ITEMS.LOCALE)}>
                                                                <FormattedNumber
                                                                    value={choice.price / 100.0}
                                                                    style="currency"
                                                                    minimumFractionDigits={2}
                                                                    maximumFractionDigits={2}
                                                                    currency={currency}/>
                                                             </IntlProvider>
                                                        </span>
                                                </div>
                                                <div className="choices row">
                                                    {choice.option ?
                                                        <span>
                                                                    {getProdOptionsFromCart(choice)}
                                                            &nbsp;</span>
                                                        : null
                                                    }
                                                    {choice.msg ?
                                                        <span>{choice.msg}&nbsp;</span>
                                                        : null
                                                    }
                                                </div>
                                                <div className="choices row">
                                                    {choice.extras ?
                                                        <>
                                                            {getProdExtrasFromCart(choice, state.outOfStockExtras)}
                                                        </>
                                                        : null
                                                    }
                                                </div>
                                            </div>
                                            :
                                            <div key={productIndex + product} className="product with-quantity-modifier"
                                                 data-qa="product with-quantity-modifier">
                                                <div className="row">
                                                    <QuantityModifier
                                                        onlyLoggedUser={false}
                                                        quantity={choice.quantity}
                                                        increaseQuantity={state.isSubmitBtnEnabled ? increaseQuantity(product, choice) : void (0)}
                                                        decreaseQuantity={state.isSubmitBtnEnabled ? decreaseQuantity(product, choice) : void (0)}
                                                    />
                                                    <span
                                                        className={state.outOfStock?.includes(product.pid) ? "prod-name danger ml-0" : "prod-name ml-0"}>
                                                            {getProdName(product)}
                                                        </span>
                                                    <span className="prod-price">&nbsp;
                                                        <IntlProvider
                                                            locale={StorageService.getItem(LOCALSTORAGE_ITEMS.LOCALE)}>
                                                                 <FormattedNumber
                                                                     value={
                                                                         choice.price / 100.0}
                                                                     style="currency"
                                                                     minimumFractionDigits={2}
                                                                     maximumFractionDigits={2}
                                                                     currency={currency}/>
                                                                 </IntlProvider>
                                                        </span>
                                                </div>
                                            </div>
                                    )}
                                </div>
                            )}
                            {state.place === places.TAKE_AWAY  ?
                                <div className="total-container row">
                                <span className="total-prod-nr">
                                    {getTotalProducts(getProductsOrderFromCart(state.currentCart))}
                                    &nbsp;</span>
                                    <span
                                        className="total-prod-label">{getTotalProducts(getProductsOrderFromCart(state.currentCart)) !== 1 ?
                                        <FormattedMessage id="Products"/> : <FormattedMessage id="Product"/>}</span>
                                    <span className="total-price">
                                     <IntlProvider locale={StorageService.getItem(LOCALSTORAGE_ITEMS.LOCALE)}>
                                     <FormattedNumber
                                         value={getTotalPrice(getProductsOrderFromCart(state.currentCart)) / 100.0}
                                         style="currency"
                                         minimumFractionDigits={2}
                                         maximumFractionDigits={2}
                                         currency={currency}/>
                                     </IntlProvider>
                                </span>
                                </div>

                                :
                                <>
                                    {(shopDetails.merchantConfig.hasDeliveryFee &&
                                            (shopDetails.merchantConfig.deliveryFee === 0 ||
                                                (!shopDetails.merchantConfig.minAmountForFreeDelivery ||
                                                    (shopDetails.merchantConfig.minAmountForFreeDelivery > getTotalPrice(getProductsOrderFromCart(state.currentCart))))))
                                        && <div className="subtotal-container row">
                                        <span className="subtotal-label">
                                             <FormattedMessage
                                                 id="Subtotal"
                                                 defaultMessage={"Subtotal"}
                                             />
                                        </span>
                                            <span className="total-price">
                                             <IntlProvider locale={StorageService.getItem(LOCALSTORAGE_ITEMS.LOCALE)}>
                                             <FormattedNumber
                                                 value={getTotalPrice(getProductsOrderFromCart(state.currentCart)) / 100.0}
                                                 style="currency"
                                                 minimumFractionDigits={2}
                                                 maximumFractionDigits={2}
                                                 currency={currency}/>
                                             </IntlProvider>
                                        </span>
                                        </div>}

                                    {shopDetails.merchantConfig.hasDeliveryFee === true &&
                                        <div className="delivery-fee-container row">
                                        <span className="delivery-fee-label">
                                            <FormattedMessage id="DeliveryFee"/>
                                        </span>
                                            <span className="total-price">
                                            {getTotalPrice(getProductsOrderFromCart(state.currentCart)) > shopDetails.merchantConfig.minAmountForFreeDelivery ?
                                                <IntlProvider
                                                    locale={StorageService.getItem(LOCALSTORAGE_ITEMS.LOCALE)}>
                                                    <FormattedNumber
                                                        value={0}
                                                        style="currency"
                                                        minimumFractionDigits={2}
                                                        maximumFractionDigits={2}
                                                        currency={currency}/>
                                                </IntlProvider>
                                                :
                                                <IntlProvider
                                                    locale={StorageService.getItem(LOCALSTORAGE_ITEMS.LOCALE)}>
                                                    <FormattedNumber
                                                        value={shopDetails.merchantConfig.deliveryFee / 100.0}
                                                        style="currency"
                                                        minimumFractionDigits={2}
                                                        maximumFractionDigits={2}
                                                        currency={currency}/>
                                                </IntlProvider>
                                            }

                                        </span>
                                        </div>}


                                    <div className="total-container row">
                                    <span className="total-prod-nr">
                                        {getTotalProducts(getProductsOrderFromCart(state.currentCart))}
                                        &nbsp;
                                    </span>
                                        <span
                                            className="total-prod-label">{getTotalProducts(getProductsOrderFromCart(state.currentCart)) !== 1 ?
                                            <FormattedMessage id="Products"/> : <FormattedMessage id="Product"/>}</span>
                                        <span className="total-price">
                                            {
                                                shopDetails.merchantConfig.hasDeliveryFee === false || getTotalPrice(getProductsOrderFromCart(state.currentCart)) > shopDetails.merchantConfig.minAmountForFreeDelivery ?

                                                    <IntlProvider
                                                        locale={StorageService.getItem(LOCALSTORAGE_ITEMS.LOCALE)}>
                                                        <FormattedNumber
                                                            value={getTotalPrice(getProductsOrderFromCart(state.currentCart)) / 100.0}
                                                            style="currency"
                                                            minimumFractionDigits={2}
                                                            maximumFractionDigits={2}
                                                            currency={currency}/>
                                                    </IntlProvider>

                                                    :

                                                    <IntlProvider
                                                        locale={StorageService.getItem(LOCALSTORAGE_ITEMS.LOCALE)}>
                                                        <FormattedNumber
                                                            value={getTotalPrice(getProductsOrderFromCart(state.currentCart)) / 100.0 + shopDetails.merchantConfig.deliveryFee / 100.0}
                                                            style="currency"
                                                            minimumFractionDigits={2}
                                                            maximumFractionDigits={2}
                                                            currency={currency}/>
                                                    </IntlProvider>
                                            }

                                    </span>
                                    </div>
                                </>
                            }


                        </div>
                    </section>
                    {/*END ORDER DETAILS*/}


                    {/*START TABS CONTAINER*/}
                    <section className="tabs-container">
                        <div className="row tabs-row">

                            {(allowOrdering && allowTakeAwayDeliveryOrdering && estimatedDeliveryTime !== null) && <a id={places.DELIVERY} onClick={(e) => changeSelectedPlace(places.DELIVERY)}
                                                                                                       className={state.place === places.DELIVERY ? "tab-link active" : "tab-link"}>
                                <FormattedMessage id="Delivery"/>
                            </a>}
                            {(allowOrdering && allowTakeAwayPickupOrdering && pickupTime !== null) && <a id={places.TAKE_AWAY} onClick={(e) => changeSelectedPlace(places.TAKE_AWAY)}
                                                                                              className={state.place === places.TAKE_AWAY ? "tab-link active" : "tab-link"}>
                                <FormattedMessage id="Pickup"/>
                            </a>}
                        </div>
                    </section>
                    {/*END TABS CONTAINER*/}

                    {/*START ORDER DETAILS CARD -> ORDER-DETAILS */}
                    <section className="order-details-card">
                        <header className="order-details-card-header neutral">
                            <FormattedMessage id="OrderDetails"/>
                        </header>
                        <div className="card-content">

                            {
                                state.place === places.TAKE_AWAY ?
                                    <>
                                        <div className="info row">
                                            <span className="info-label">
                                                <FormattedMessage id="EstimatedPickupTime"/>
                                            </span>
                                            <span className="info-value">
                                                <Moment
                                                    format={DATE_FORMAT.HOUR_MINUTES}
                                                    date={getEstimatedTimePickup()}
                                                />
                                            </span>
                                        </div>

                                        <div className="info row">
                                            <span className="info-label pickup-address"><FormattedMessage
                                                id="PickupAddress"/></span>

                                            <a target="_blank"
                                               href={shopDetails.data.loc?.coordinates ? "https://www.google.com/maps/search/?api=1&query=" + shopDetails.data.loc?.coordinates[0][1] + "," + shopDetails.data.loc?.coordinates[0][0] : void (0)}
                                               className="info-value address">
                                                <img
                                                    src={locationImg}/>
                                                {shopDetails.data.address}
                                            </a>

                                        </div>
                                    </>
                                    :
                                    <>
                                        <div className="info row">
                                            <span className="info-label">
                                                <FormattedMessage id="EstimatedDeliveryTime"/>
                                            </span>
                                            <span className="info-value">
                                                <Moment
                                                    format={DATE_FORMAT.HOUR_MINUTES}
                                                    date={getEstimatedTimeDelivery()}
                                                />
                                            </span>
                                        </div>

                                        {deliveryInfo && <div className="info row">
                                  <span className="info-label full-width  danger">
                                               {deliveryInfo}
                                            </span>
                                        </div>}

                                    </>
                            }


                        </div>
                    </section>
                    {/*START ORDER DETAILS CARD -> ORDER-DETAILS */}


                    {/*START ORDER DETAILS CARD -> CONTACT INFORMATION */}

                    <section className="order-details-card">
                        <header className="order-details-card-header neutral">
                            <FormattedMessage id="ContactInformation"/>
                        </header>

                        <div className="form-group">


                            <div className="row delivery-name">
                                <div className="row">
                                    <label>{<FormattedMessage id="Name"/>}</label>
                                    <input
                                        type="text"
                                        onChange={e => handleNameInput(e.target.value)}
                                        maxLength={150}
                                        autoComplete="off"
                                        value={
                                            userInfo?.firstName && userInfo?.lastName
                                                ? userInfo.firstName + " " + userInfo.lastName
                                                : null
                                        }
                                        data-qa="takeaway-name-input"
                                    />
                                </div>

                            </div>

                            <div className="row">
                                <label>{<FormattedMessage id="PhoneNo"/>}</label>
                                <input
                                    type="text"
                                    onFocus={() => toUpdatePhone()}
                                    onClick={() => toUpdatePhone()}
                                    maxLength={20}
                                    readOnly={true}
                                    value={userInfo?.phone ? userInfo?.phone : null}
                                    autoComplete="off"
                                />
                            </div>
                            {(state.place === places.DELIVERY) && <div className="row delivery-address">
                                <label>{<FormattedMessage id="DeliveryAddress"/>}</label>
                                <input
                                    type="text"
                                    onChange={e => handleAddressInput(e.target.value)}
                                    autoComplete="off"
                                    data-qa="takeaway-delivery-address-input"
                                />
                            </div>}


                        </div>
                    </section>

                    {/*END ORDER DETAILS CARD -> CONTACT INFORMATION */}

                    {/*START PAYMENT */}
                    <section className="payment">
                        <header className="section-heading">
                            <h1>{<FormattedMessage id="Payment"/>}</h1>
                        </header>


                        {/*START TABS CONTAINER*/}
                        <section className="tabs-container">
                            <div className="row tabs-row">

                                {/*IF PICKUP SELECTED*/}

                                {state.place === places.TAKE_AWAY ? (

                                    <>
                                        {allowedPaymentMethodsForPickup?.includes(PAYMENT_TYPES.ONLINE) &&

                                            <>
                                                {(userType === USER_TYPES.ANONYMOUS || userType === null) ?
                                                    <a className="tab-link disabled" data-qa="payment-online-btn"
                                                       onClick={showNoAccountPopup}>
                                                        <FormattedMessage id="Online"/>
                                                    </a>
                                                    :
                                                    <a className={state.selectedPaymentType === PAYMENT_TYPES.ONLINE ? "tab-link active" : "tab-link"}
                                                       data-qa="payment-online-btn"
                                                       onClick={() => setPaymentType(PAYMENT_TYPES.ONLINE)}>
                                                        <FormattedMessage id="Online"/>
                                                    </a>
                                                }
                                            </>
                                        }
                                    </>
                                ) : state.place === places.DELIVERY ? (

                                    <>
                                        {allowedPaymentMethodsForDelivery?.includes(PAYMENT_TYPES.ONLINE) &&

                                            <>
                                                {(userType === USER_TYPES.ANONYMOUS || userType === null) ?
                                                    <a className="tab-link disabled" data-qa="payment-online-btn"
                                                       onClick={showNoAccountPopup}>
                                                        <FormattedMessage id="Online"/>
                                                    </a>
                                                    :
                                                    <a className={state.selectedPaymentType === PAYMENT_TYPES.ONLINE ? "tab-link active" : "tab-link"}
                                                       data-qa="payment-online-btn"
                                                       onClick={() => setPaymentType(PAYMENT_TYPES.ONLINE)}>
                                                        <FormattedMessage id="Online"/>
                                                    </a>
                                                }
                                            </>
                                        }
                                    </>
                                ) : null}


                                <a
                                    className={state.selectedPaymentType === PAYMENT_TYPES.AT_PICKUP || state.selectedPaymentType === PAYMENT_TYPES.AT_DELIVERY ? "tab-link active" : "tab-link"}
                                    onClick={() => setPaymentType(state.selectedPaymentType === PAYMENT_TYPES.AT_DELIVERY ? PAYMENT_TYPES.AT_DELIVERY : PAYMENT_TYPES.AT_PICKUP)}>
                                    {state.place === places.TAKE_AWAY ?
                                        <FormattedMessage id="AtPickup"/>
                                        :
                                        <FormattedMessage id="AtDelivery"/>
                                    }
                                </a>
                            </div>

                        </section>
                        {/*END TABS CONTAINER*/}
                    </section>
                    {/*END PAYMENT */}

                    {state.errorMsg != null ? <div className="error-div">&#9888;&nbsp;{state.errorMsg}</div> : null}

                </main>
                {paymentStatus === PAYMENT_STATUSES.PENDING &&
                    <div className="row centered-content dot-container"><span><FormattedMessage id="PaymentPending"/></span><span className="dots dot-blink"></span></div>
                }
                {/*END PAGE-CONTENT*/}


                <TakeAwayOrderReviewActionsBar
                    isVisible={!!getTotalProducts(getProductsOrderFromCart(state.currentCart))}
                    totalProducts={getTotalProducts(getProductsOrderFromCart(state.currentCart))}
                    totalPrice={
                        state.place === places.TAKE_AWAY ?
                            <IntlProvider locale={StorageService.getItem(LOCALSTORAGE_ITEMS.LOCALE)}>
                                <FormattedNumber
                                    value={getTotalPrice(getProductsOrderFromCart(state.currentCart)) / 100.0}
                                    style="currency"
                                    minimumFractionDigits={2}
                                    maximumFractionDigits={2}
                                    currency={currency}
                                />
                            </IntlProvider>
                            :
                            shopDetails.merchantConfig.hasDeliveryFee === false ||
                            getTotalPrice(getProductsOrderFromCart(state.currentCart)) > shopDetails.merchantConfig.minAmountForFreeDelivery ?

                                <IntlProvider locale={StorageService.getItem(LOCALSTORAGE_ITEMS.LOCALE)}>
                                    <FormattedNumber
                                        value={getTotalPrice(getProductsOrderFromCart(state.currentCart)) / 100.0}
                                        style="currency"
                                        minimumFractionDigits={2}
                                        maximumFractionDigits={2}
                                        currency={currency}
                                    />
                                </IntlProvider>
                                :
                                <IntlProvider locale={StorageService.getItem(LOCALSTORAGE_ITEMS.LOCALE)}>
                                    <FormattedNumber
                                        value={getTotalPrice(getProductsOrderFromCart(state.currentCart)) / 100.0 + shopDetails.merchantConfig.deliveryFee / 100.0}
                                        style="currency"
                                        minimumFractionDigits={2}
                                        maximumFractionDigits={2}
                                        currency={currency}
                                    />
                                </IntlProvider>
                    }
                    buttonName={<FormattedMessage id="SendOrder"/>}
                    btnClassName={(state.isSubmitBtnEnabled && paymentStatus !== PAYMENT_STATUSES.PENDING)  ? "btn btn-default btn-xl" : "btn btn-default btn-xl btn-disabled"}
                    buttonAction={() => {
                        state.isSubmitBtnEnabled ? handleSubmit() : void (0);
                    }}
                    dataQAIdentifier={"order-review-submit-btn"}
                />

                {state.loading ?
                    <div className="spinner" data-qa="spinner"><Spinner/></div>
                    : null
                }
            </>
        )
        :
        null
}

export default TakeAwayOrderReview;
